import { render, staticRenderFns } from "./DrillResultMath.vue?vue&type=template&id=09b1d5bb&scoped=true&lang=pug&"
import script from "./DrillResultMath.vue?vue&type=script&lang=ts&"
export * from "./DrillResultMath.vue?vue&type=script&lang=ts&"
import style0 from "./DrillResultMath.vue?vue&type=style&index=0&id=09b1d5bb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b1d5bb",
  null
  
)

export default component.exports